module.exports = __webpack_public_path__ + "static/media/Food.51ecaa9a.png";